module.exports = __webpack_public_path__ + "img/CIRCULO.5765a8b8.svg";